
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1410Dialog extends Serenity.EntityDialog<Report_1410Row, any> {
        protected getFormKey() { return Report_1410Form.formKey; }
        protected getIdProperty() { return Report_1410Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1410Row.localTextPrefix; }
        protected getNameProperty() { return Report_1410Row.nameProperty; }
        protected getService() { return Report_1410Service.baseUrl; }
        protected getDeletePermission() { return Report_1410Row.deletePermission; }
        protected getInsertPermission() { return Report_1410Row.insertPermission; }
        protected getUpdatePermission() { return Report_1410Row.updatePermission; }

        protected form = new Report_1410Form(this.idPrefix);

    }
}